import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type {
	CreateOneShopExportModelDto,
	ShopDto,
} from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

type UseAddExportModelParams = {
	onSuccess?: () => void;
};

export default function useAddExportModel(
	shop: ShopDto,
	params?: UseAddExportModelParams,
) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateShop = useInvalidateShop(shop.id);
	const mutation = $api.useMutation("post", "/shops/{shopId}/export-models");

	return useMutation({
		onSuccess: () => {
			params?.onSuccess?.();
			invalidateShop();
			successNotification();
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: (exportModel: CreateOneShopExportModelDto) => {
			if (!shop) throw new Error("Shop not found");
			return mutation.mutateAsync({
				params: { path: { shopId: shop.id } },
				body: exportModel,
			});
		},
	});
}
